import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { VideoStudiosContext, IVideoStudiosContext } from '../../../videoStudiosState/videoStudiosContext';
import style from './CreateBtn.module.scss';

const CreateBtn: React.FC = () => {
	const { changeTypeOfModalWindow } = useContext<IVideoStudiosContext>(VideoStudiosContext);

	const handleRedirect = () => {
		changeTypeOfModalWindow('createStudio');
	};

	return (
		<Button
			className={style.btn}
			theme="primaryBlue"
			data-test="CreateBtn"
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}
			onClick={handleRedirect}>
			<Text translationNameSpace="listing" translationKey="addStudioButton" asFragment={true} />
		</Button>
	);
};

export default CreateBtn;
